/**
 * Configuration Model for Left Menu Background
 * Right now colors are too spread across several places
 * TODO: Get all possible colors
 */
export class LeftNavMenuStyleModel {
	public backgroundColor?: string;
	public item?: {
		textColor?: string;
		separatorColor?: string;
		active?: {
			iconColor?: string;
			textColor?: string;
			backgroundColor?: string;
		}
	};
	public menuToggle?: {
		backgroundColor?: string;
	};

	constructor() {
		this.backgroundColor = '#2b2b2b';
		this.item = {
			textColor: '#707070',
			separatorColor: '#454545',
			active: {
				iconColor: '#68b300',
				textColor: '#707070',
				backgroundColor: '#454545'
			}
		};
		this.menuToggle = {
			backgroundColor: '#000000',
		};
	}
}
